import { Box, Card, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { ETheme } from '../../../shared/enums/user/ETheme';
import { formatDate } from '../../../shared/functions/formatDate';
import { handleError } from '../../../shared/functions/handleError';
import { IProject } from '../../../shared/interfaces/projects/IProject';
import { IUser } from '../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../shared/mui/palettes';
import { RootState } from '../../../store/store';
import { AdminProjectsService } from '../../admin/projects/service';

const projectKeys = [
  { name: 'name', colSize: 6 },
  {
    name: 'clientName',
    colSize: 6,
  },
  {
    name: 'status',
    colSize: 4,
  },
  {
    name: 'createdAt',
    colSize: 4,
  },
  {
    name: 'projectType',
    colSize: 4,
  },
  {
    name: 'users',
    colSize: 12,
  },
  {
    name: 'description',
    colSize: 12,
  },
];
const ProjectUpdate = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { theme } = useSelector(
    (state: RootState) => state?.auth?.userData,
  ) as IUser;
  const { t } = useTranslation();
  const [project, setProject] = useState<IProject | null>(null);

  const getProjectKey = (project: IProject, projectKey: string): string => {
    const value = String(project[projectKey as keyof typeof project]);
    const normalProperty = project[projectKey as keyof typeof project];
    const transformations: Record<string, (val: string) => string> = {
      name: (val) => val,
      description: (val) => val,
      clientName: (val) => val,
      status: (val) => t(`projects.status.${val}`),
      createdAt: (val) => formatDate(val),
      projectType: () =>
        (normalProperty as string[])?.length
          ? (normalProperty as string[])
              ?.map((item) => t(`projectTypes.${item}`))
              ?.join(', ')
          : '-',

      users: () =>
        (normalProperty as IUser[])
          ?.map((item) => item.displayName)
          ?.join(', '),
    };

    return transformations[projectKey]?.(value) ?? value;
  };
  useEffect(() => {
    AdminProjectsService.getSingle(Number(id))
      .then(setProject)
      .catch(handleError);
  }, [id]);
  return (
    <Card>
      <Grid container spacing={2}>
        {project &&
          projectKeys?.map((projectKey) => {
            return (
              <Grid
                key={projectKey?.name}
                sx={{
                  py: '10px',
                  borderBottom: `1px solid ${theme === ETheme.LIGHT ? lightPalette.primary.light : darkPalette.background.light}`,
                }}
                size={{ md: projectKey?.colSize, xs: 12 }}
              >
                <Typography
                  variant={'subtitle1'}
                  color={lightPalette.text.gray}
                  sx={{
                    fontWeight: '300',
                  }}
                >
                  {t(`general.${projectKey?.name}`)}
                </Typography>
                <Typography variant={'body1'}>
                  {!!getProjectKey(project, projectKey?.name)?.length
                    ? getProjectKey(project, projectKey?.name)
                    : '-'}
                </Typography>
              </Grid>
            );
          })}
      </Grid>
      <Box sx={{ mt: '20px', display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant={'contained'}
          color={'secondary'}
          size={'small'}
          onClick={() => navigate(-1)}
        >
          {t('button.cancel')}
        </Button>
      </Box>
    </Card>
  );
};

export default ProjectUpdate;
